import { render, staticRenderFns } from "./ContadorLectoras.vue?vue&type=template&id=91ec2870&"
import script from "./ContadorLectoras.vue?vue&type=script&lang=js&"
export * from "./ContadorLectoras.vue?vue&type=script&lang=js&"
import style0 from "./ContadorLectoras.vue?vue&type=style&index=0&id=91ec2870&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports